import React from "react";

const TwoCheckIcon = ({
  width = 16,
  height = 8,
  color = "",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 8"
    fill="none"
    className={className}
  >
    <path
      d="M5.21016 4.00079L8.27361 7.20078L14.3999 0.800781M1.59985 4.00079L4.6633 7.20078M10.7902 0.800781L8.45944 3.25766"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default TwoCheckIcon;
